<div class="main_content px-3 position-relative">

    <div class="container-fluid py-3">
        <div class="title mb-4">
            <h3>Manage Brands</h3>
        </div>
        <div class="my-2">
            <button class="btn btn-success" (click)="openModal(UploadFileModal)">
                <i class="fa-solid fa-plus"></i> Add Brand
            </button>
        </div>

        <div class="row">
            <div class="col-lg-12 col-md-12 ">
                <div class="white_box shadow p-3">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Name</th>
                                <th scope="col">Image</th>
                                <th scope="col">URL</th>
                                <th scope="col">Description</th>
                                <th scope="col">title</th>
                                <th scope="col">Created At</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of brands; let i = index;">
                                <th scope="row">{{i + 1}}</th>
                                <td>{{item.name}}</td>
                                <th scope="row">
                                    <img loading="lazy" [src]="imgUrl + item.image" alt="Brand Image" class="img-thumbnail"
                                        style="width: 200px;" />
                                </th>
                                <td>{{item.url}}</td>
                                <td>{{item.description}}</td>
                                <td>{{item.title}}</td>
                                <td>{{item.createdAt | date:'dd-MM-yyyy'}}</td>
                                <td>
                                    <div class="btn-group" role="group">
                                        <button type="button" class="btn btn-warning"
                                            (click)="openModal(UploadFileModal, item)">
                                            <i class="fa-solid fa-pen-to-square"></i>
                                        </button>
                                        <button type="button" class="btn btn-danger" (click)="handleDelete(item.id)">
                                            <i class="fa-solid fa-trash"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #UploadFileModal let-modal>
    <div class="modal-content">
        <div class="card">
            <div class="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
                <h5 class="modal-title mb-0">Add Brand</h5>
                <button type="button" class="btn-close btn-close-white" aria-label="Close"
                    (click)="modalService.dismissAll()"></button>
            </div>
            <div class="card-body">
                <p class="card-text">Please select a file to upload.</p>
                <div class="mb-3">
                    <input class="form-control" type="file" accept="image/*" (change)="onFileSelected($event)" />
                    <div *ngIf="thumbnail" class="thumbnail-preview mt-3">
                        <img loading="lazy" [src]="thumbnail" alt="Thumbnail Preview" class="img-thumbnail" />
                    </div>
                </div>
                <div class="mb-3">
                    <label for="name" class="form-label">Name</label>
                    <input type="text" class="form-control" id="name" [(ngModel)]="name" placeholder="Enter name" />
                </div>
                <div class="mb-3">
                    <label for="url" class="form-label">URL</label>
                    <input type="text" class="form-control" id="url" [(ngModel)]="url" placeholder="Enter URL" />
                </div>

                <div class="mb-3">
                    <label for="name" class="form-label">Description</label>
                    <input type="text" class="form-control" id="name" [(ngModel)]="description" placeholder="Enter name" />
                </div>

                <div class="mb-3">
                    <label for="name" class="form-label">Title</label>
                    <input type="text" class="form-control" id="name" [(ngModel)]="title" placeholder="Enter Title" />
                </div>

                
            </div>
            <div class="card-footer d-flex justify-content-end">
                <button type="button" class="btn btn-primary me-2" (click)="handleUpload()"
                    [disabled]="isUploading">Upload</button>
                <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()"
                    [disabled]="isUploading">Cancel</button>
            </div>
        </div>
    </div>
</ng-template>